import React from 'react';

import { ICustomisationRibbon } from '../../../types/ICustomisationRibbon';

import Icon from '../../../../ui/icon/icon';

const CustomisationRibbon: React.FC<ICustomisationRibbon> = ({
                                                               id,
                                                               handleWidgetMove,
                                                               widgets,
                                                               changeNewIndex,
                                                               changeOldIndex,
                                                               handleWidgetChange,
                                                               homePage,
                                                             }) => {

  return (
    <div id={'customisation'}>
      <Icon
        className={'pointer'}
        name={'fa-solid fa-chevron-left'}
        onClick={() => {
          handleWidgetMove(id);
          const index = widgets.findIndex((widget) => {
            if (widget.id) {
              return widget.id === id;
            } else {
              return widget.widget.id === id;
            }
          });
          if (index > 0) {
            changeOldIndex(index);
            changeNewIndex(index - 1);
          } else {
            changeOldIndex(null);
            changeNewIndex(null);
          }
        }}
      />
      <Icon
        className={'pointer'}
        name={'fa-solid fa-chevron-right'}
        onClick={() => {
          handleWidgetMove(id);
          const index = widgets.findIndex((widget) => {
            if (widget.id) {
              return widget.id === id;
            } else {
              return widget.widget.id === id;
            }
          });
          if (index < widgets.length - 1) {
            changeOldIndex(index);
            changeNewIndex(index + 1);
          } else {
            changeOldIndex(null);
            changeNewIndex(null);
          }
        }}
      />
      {!homePage && <Icon
        className={'pointer'}
        name={'fas fa-times-circle'}
        onClick={() => {
          if (homePage) {
            handleWidgetChange(
              widgets.filter((widget) => widget.widget.id !== id),
            );
          } else {
            handleWidgetChange(
              widgets.map((widget) => {
                if (widget.id === id) {
                  return { ...widget, visible: false };
                } else {
                  return { ...widget };
                }
              }),
            );
          }
        }}
      />}
    </div>
  );
};

export default CustomisationRibbon;
